import {StoryTool} from "../StoryTool";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFilePen, faHammer, faNetworkWired, faNoteSticky} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import {OutlineContent} from "./OutlineContent";

export class Outlines implements StoryTool {
    id = 'outlines'
    name = "Outlines"
    paths = [
        `/projects/:projectId/stories/:storyId/${this.id}`
    ]
    enabled = false
    icon = <FontAwesomeIcon icon={faNetworkWired}/>
    entryPoint = <OutlineContent/>
    link = (projectId?: string, storyId?: string) => `/projects/${projectId}/stories/${storyId}/${this.id}`
}